import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouteLink } from 'react-router';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ExtensionIcon } from './extension-icon';
import { ExtensionDetailRoutes } from '../../pages/extension-detail/extension-detail-routes';
import { createRoute } from '../../utils';
import { MONO_FONT } from '../../default/theme';
export const ExtensionHeader = ({ extension, actions }) => {
    const publicRoute = createRoute([ExtensionDetailRoutes.ROOT, extension.namespace, extension.name]);
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '1.25rem',
            flexWrap: 'wrap',
            pb: '1.5rem',
            mb: '1.75rem',
            borderBottom: '1px solid',
            borderColor: 'divider'
        }, children: [_jsx(Box, { sx: {
                    flexShrink: 0,
                    width: '4rem',
                    height: '4rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }, children: _jsx(ExtensionIcon, { extension: extension, sx: { width: '4rem', maxHeight: '4rem', objectFit: 'contain' } }) }), _jsxs(Box, { sx: { flex: 1, minWidth: '12rem' }, children: [_jsx(Typography, { component: 'h1', noWrap: true, sx: { fontSize: '1.625rem', fontWeight: 800, letterSpacing: '-0.02em', mb: '0.375rem' }, children: extension.displayName ?? extension.name }), _jsxs(Typography, { component: 'code', sx: { fontFamily: MONO_FONT, fontSize: '0.8125rem', color: 'text.disabled' }, children: [extension.namespace, ".", extension.name] }), extension.description ? (_jsx(Typography, { sx: {
                            fontSize: '0.84375rem',
                            color: 'text.secondary',
                            lineHeight: 1.5,
                            mt: '0.5rem',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }, children: extension.description })) : null] }), _jsxs(Stack, { direction: 'row', spacing: 2, sx: { flexShrink: 0 }, children: [actions, extension.active !== false && !extension.removed ? (_jsx(Button, { variant: 'outlined', component: RouteLink, to: publicRoute, target: '_blank', rel: 'noopener', startIcon: _jsx(OpenInNewIcon, {}), children: "View public page" })) : null] })] }));
};
//# sourceMappingURL=extension-header.js.map